import { DefaultHeaderCell } from "../../Layout/DataGrid";
import React from "react";
import i18n from "i18next";

const HeaderComponent = () => {
  return (
    <div className="data-grid__column --header">
      <DefaultHeaderCell className="--last" label={i18n.t("millOrder.millOrder")} />
      <DefaultHeaderCell className="--first" label={i18n.t("millOrder.PO")} />
      <DefaultHeaderCell label={i18n.t("millOrder.addressBook")} />
      <DefaultHeaderCell label={i18n.t("millOrder.ship")} />
      <DefaultHeaderCell label={i18n.t("millOrder.product")} />
      <DefaultHeaderCell className="--last" label={i18n.t("millOrder.dimensions")} />
      <DefaultHeaderCell className="--first" label={i18n.t("millOrder.status")} />
      <DefaultHeaderCell label={i18n.t("millOrder.confirmed")} />
      <DefaultHeaderCell label={i18n.t("millOrder.planning")} />
      <DefaultHeaderCell label={i18n.t("millOrder.produced")} />
      <DefaultHeaderCell label={i18n.t("millOrder.loaded")} />
      <DefaultHeaderCell label={i18n.t("millOrder.shipped")} />
      <DefaultHeaderCell className="--last" label={i18n.t("millOrder.millStatus")} />
      <DefaultHeaderCell className="--first" label={i18n.t("millOrder.carrier")} />
      <DefaultHeaderCell label={i18n.t("millOrder.bol")} />
      <DefaultHeaderCell label={i18n.t("millOrder.vehicle")} />
      <DefaultHeaderCell label={i18n.t("millOrder.loadedDate")} />
      <DefaultHeaderCell label={i18n.t("millOrder.shippedDate")} />
    </div>
  );
};

export default HeaderComponent;



// WEBPACK FOOTER //
// ./src/components/MillOrder/DataGrid/HeaderComponent.js